module.exports = __webpack_public_path__ + "img/now-logo.e1d091fd.png";